import { FormControlLabel, Checkbox } from "@mui/material";
import React, { useEffect, useState } from "react";
import Input from "../../../components/Commons/Input";
import { Select } from "../../../components/Commons/Select";
import { useTranslation } from "react-i18next";
import { workAddressSelect } from "../../../utils/constants/constant";
import { Regex } from "../../../utils/constants";
import { stringHelper } from "../../../utils/helpers";
import {
  fetchAddressCompany,
  fetchGetAddressData,
} from "../../../utils/helpers/api";
import { useGlobalState } from "../../../contexts/GlobalContext";
import CustomAutocomplete from "../../../components/Commons/AutoComplete";
import Minus from "../../../components/svg/Minus";
import Plus from "../../../components/svg/Plus";
import ErrorMsg from "../../../components/Commons/ErrorMsg";

const WorkPlace: React.FC<IContactFormProps> = (props) => {
  const { t } = useTranslation();
  const { globalState } = useGlobalState();
  const {
    isEdit = true,
    onChangeData,
    onChangeValidate,
    onChangeSubData,
    onGetErr,
    formData,
    errorMess,
    id,
    forceWorkPlaceValidate,
  } = props;
  const [state, setState] = useState<IWorkPlaceFormState>({
    userMetaData: {},
  });
  const { userMetaData } = state;
  const { user } = globalState;
  const [visibleForms, setVisibleForms] = useState<boolean>(true);
  const [subValue, setSubValue] = useState({
    companyName: "",
    zip01: "",
    zip02: "",
    prefectureCode: 0,
    phone01: "",
    phone03: "",
    phone02: "",
    mobile01: "",
    mobile02: "",
    mobile03: "",
    fax1: "",
    fax2: "",
    fax3: "",
    departmentName: "",
  });

  const [errors, setErrors] = useState({
    work_post_code: "",
    prefectureCode: "",
    work_phone: "",
    zip01: "",
    phone01: "",
    zip02: "",
    phone03: "",
    phone02: "",
    companyName: "",
    mobile01: "",
    mobile02: "",
    mobile03: "",
    city: "",
    line: "",
    fax1: "",
    fax2: "",
    fax3: "",
    departmentName: "",
  });

  useEffect(() => {
      // handle error when change status 連絡先種別
      if(userMetaData?.profile?.contactType != undefined)
        if(userMetaData?.profile?.contactType != formData?.profile?.contactType) {
          const nameFields = [ 'companyName', 'zip01', 'zip02', 'phone01', 'phone02', 'phone03', 'departmentName'] as const;
          if(formData?.profile?.contactType === 1 && !forceWorkPlaceValidate) {
            nameFields.forEach(field => {
              if(errors[field] === t("common.required")) {
                setErrors(prevErrors => ({
                  ...prevErrors,
                  [field]: "",
                }));
              }
            });
          } else {
            nameFields.forEach(field => {
              if(subValue[field] == '') {
                setErrors(prevErrors => ({
                  ...prevErrors,
                  [field]: t("common.required"),
                }));
              }
            });
          }
        }
    }, [formData?.profile?.contactType]);

  useEffect(() => {
    if (onChangeData) {
      onChangeData(userMetaData ?? {});
    }
    if (onChangeValidate) {
      onChangeValidate(handleCountCurrentValid());
    }
    if (onGetErr) {
      onGetErr(Object.values(errors).some(Boolean));
    }
  }, [state, errors, subValue]);

  useEffect(() => {
    if (onChangeSubData) {
      onChangeSubData(subValue);
    }
  }, [subValue]);

  useEffect(() => {
    if (errorMess && errorMess.length > 0) {
      errorMess.forEach((error) => {
        setErrors((prevErrors) => {
          if (error.field && Object.keys(prevErrors).includes(error.field)) {
            return {
              ...prevErrors,
              [error.field]: error.mess,
            };
          }
          return prevErrors;
        });
      });
    }
  }, [errorMess]);

  useEffect(() => {
    if (formData) {
      setState((prevState) => {
        if (JSON.stringify(prevState.userMetaData) !== JSON.stringify(formData)) {
          return {
            ...prevState,
            userMetaData: {
              ...formData,
            },
          };
        }
        return prevState;
      });
    }

    if (formData?.profile?.address?.prefectureCode) {
      setSubValue((prevState) => {
        return {
          ...prevState,
          prefectureCode: formData?.profile?.address?.prefectureCode ?? 0
        };
      });
    }

    if (formData?.workPlaceInfo?.departmentName) {
      setSubValue((prevState) => {
        return {
          ...prevState,
          departmentName: formData?.workPlaceInfo?.departmentName ?? ""
        };
      });
    }
    
    if (formData?.workPlaceInfo?.mobilePhoneNumber) {
      const parts = formData?.workPlaceInfo?.mobilePhoneNumber.split("-");
      setSubValue((prevState) => {
        if (
          parts[0] !== prevState.mobile01 ||
          parts[1] !== prevState.mobile02 ||
          parts[2] !== prevState.mobile03
        ) {
          return {
            ...prevState,
            mobile01: parts[0] ?? "",
            mobile02: parts[1] ?? "",
            mobile03: parts[2] ?? "",
          };
        }
        return prevState; 
      });
    }
  
    if (formData?.workPlaceInfo?.faxNumber) {
      const parts = formData?.workPlaceInfo?.faxNumber.split("-");
      setSubValue((prevState) => {
        if (
          parts[0] !== prevState.fax1 ||
          parts[1] !== prevState.fax2 ||
          parts[2] !== prevState.fax3
        ) {
          return {
            ...prevState,
            fax1: parts[0] ?? "",
            fax2: parts[1] ?? "",
            fax3: parts[2] ?? "",
          };
        }
        return prevState;
      });
    }
  
    if (formData?.workPlaceInfo?.phoneNumber) {
      const parts = formData?.workPlaceInfo?.phoneNumber.split("-");
      setSubValue((prevState) => {
        if (
          parts[0] !== prevState.phone01 ||
          parts[1] !== prevState.phone02 ||
          parts[2] !== prevState.phone03
        ) {
          return {
            ...prevState,
            phone01: parts[0] ?? "",
            phone02: parts[1] ?? "",
            phone03: parts[2] ?? "",
          };
        }
        return prevState;
      });
    }
  
    if (formData?.workPlaceInfo?.postalCode) {
      const parts = formData?.workPlaceInfo?.postalCode.split("-");
      setSubValue((prevState) => {
        if (
          parts[0] !== prevState.zip01 ||
          parts[1] !== prevState.zip02
        ) {
          return {
            ...prevState,
            zip01: parts[0] ?? "",
            zip02: parts[1] ?? "",
          };
        }
        return prevState;
      });
    }
  
  
    if (formData?.workPlaceInfo?.companyName) {
      setSubValue((prevState) => {
        if (!prevState.companyName) {
          return {
            ...prevState,
            companyName: formData?.workPlaceInfo?.companyName ?? "",
          };
        }
        return prevState;
      });
    }
  }, [formData]);
  
  useEffect(() => {
    const updateWorkPlaceInfo = (key: string, value: string) => {
      setState((prevState) => ({
        ...prevState,
        userMetaData: {
          ...prevState.userMetaData,
          workPlaceInfo: {
            ...prevState.userMetaData?.workPlaceInfo,
            [key]: value,
          },
        },
      }));
    };

    if (subValue.zip01 && subValue.zip02) {
      const formattedPostalCode = stringHelper.formatHalfWidthText(
        `${subValue.zip01}-${subValue.zip02}`
      );
      updateWorkPlaceInfo("postalCode", formattedPostalCode);
    } else {
      updateWorkPlaceInfo("postalCode", "");
    }

    if (subValue.phone01 && subValue.phone02 && subValue.phone03) {
      const formattedPhoneNumber = stringHelper.formatHalfWidthText(
        `${subValue.phone01}-${subValue.phone02}-${subValue.phone03}`
      );
      updateWorkPlaceInfo("phoneNumber", formattedPhoneNumber);
    } else {
      updateWorkPlaceInfo("phoneNumber", "");
    }

    if (subValue.mobile01 && subValue.mobile02 && subValue.mobile03) {
      const formattedMobilePhoneNumber = stringHelper.formatHalfWidthText(
        `${subValue.mobile01}-${subValue.mobile02}-${subValue.mobile03}`
      );
      updateWorkPlaceInfo("mobilePhoneNumber", formattedMobilePhoneNumber);
    } else if (
      subValue.mobile01 === "" &&
      subValue.mobile02 === "" &&
      subValue.mobile03 === ""
    ) {
      updateWorkPlaceInfo("mobilePhoneNumber", "");
    }

    if (subValue.fax1 && subValue.fax2 && subValue.fax3) {
      const formattedFaxNumber = stringHelper.formatHalfWidthText(
        `${subValue.fax1}-${subValue.fax2}-${subValue.fax3}`
      );
      updateWorkPlaceInfo("faxNumber", formattedFaxNumber);
    } else if (
      subValue.fax1 === "" &&
      subValue.fax2 === "" &&
      subValue.fax3 === ""
    ) {
      updateWorkPlaceInfo("faxNumber", "");
    }
  }, [subValue]);

  useEffect(() => {
    if (
      subValue.zip01.length + subValue.zip02.length == 7 &&
      !errors.zip01 &&
      !errors.zip02
    ) {
      handleGetAddress(subValue.zip01 + subValue.zip02);
    }
  }, [subValue.zip01, subValue.zip02]);

  useEffect(() => {
    if (onChangeValidate) {
      onChangeValidate(handleCountCurrentValid());
    }
  }, [userMetaData?.profile?.contactType]);
  
  const handleGetAddress = async (zipCode: string) => {
    try {
      const result = await fetchGetAddressData(zipCode);
      if (result.code == 200) {
        setState((prevState) => ({
          ...prevState,
          userMetaData: {
            ...prevState.userMetaData,
            workPlaceInfo: {
              ...prevState.userMetaData?.workPlaceInfo,
              prefectureCode: parseInt(
                workAddressSelect.find(
                  (address) => address.label == result.data.pref
                )?.value ?? "0"
              ),
              city: result.data.address,
            },
          },
        }));

        setErrors((prevErrors) => ({
          ...prevErrors,
          city: "",
          prefectureCode: "",
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const isWorkPlaceRequired = forceWorkPlaceValidate || userMetaData?.profile?.contactType !== 1;

  const handleCountCurrentValid = () => {
    const fields = isWorkPlaceRequired
      ? [
          {
            field:
              userMetaData?.workPlaceInfo?.companyName && !errors.companyName,
          },
          {
            field:
              userMetaData?.workPlaceInfo?.postalCode &&
              !errors.zip01 &&
              !errors.zip02,
          },
          {
            field:
              userMetaData?.workPlaceInfo?.phoneNumber &&
              !errors.phone01 &&
              !errors.phone02 &&
              !errors.phone03,
          },
          { field: userMetaData?.workPlaceInfo?.city && !errors.city },
          { field: userMetaData?.workPlaceInfo?.line && !errors.line },
          {
            field:
              userMetaData?.workPlaceInfo?.prefectureCode &&
              !errors.prefectureCode,
          },
        ]
      : [];
        
    const validFields = fields.filter(Boolean);
    return validFields.reduce((currentValid, item) => {
      return item?.field ? currentValid + 1 : currentValid;
    }, 0);
  };

  const validateField = (field: string, value?: string) => {
    switch (field) {
      case "zip01":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.postalCodeOnlyNumbers");
        if (value && value?.length < 3)
          return t("validation.postalCodeThreeDigits");
        break;
      case "zip02":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.postalCodeOnlyNumbers");
        if (value && value?.length < 4)
          return t("validation.postalCodeFourDigits");
        break;
      case "phone01":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.landlineNumberOnlyDigits");
        if (value && value?.length < 2)
          return t("validation.twoDigitsOrMoreRequired");
        if (value && value?.length > 5)
          return t("validation.postalCodeFiveDigits");
        break;
      case "phone02":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.landlineNumberOnlyDigits");
        if (value && value?.length > 4)
          return t("validation.postalCodeFourDigits");
        break;
      case "phone03":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.landlineNumberOnlyDigits");
        if (isWorkPlaceRequired && value?.length !== 4)
          return t("validation.postalCodeFourDigits");
        break;
      case "prefectureCode":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (isWorkPlaceRequired && value === "0")
          return t("validation.selectRequired");
        break;
      case "line":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (value && value?.length > 200) return t("validation.max200chars");
        break;
      case "companyName":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (value && value?.length > 50) return t("validation.max50chars");
        break;
      case "city":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (value && value?.length > 80) return t("validation.max80chars");
        break;
      case "departmentName":
        if (isWorkPlaceRequired && value?.trim() === "")
          return t("common.required");
        if (value && value?.length > 50)
          return t("validation.max50chars");
        break;
      case "mobile01":
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.mobileNumberOnlyNumbers");
        if (value && value?.length !== 3)
          return t("validation.postalCodeThreeDigits");
        break;
      case "mobile02":
      case "mobile03":
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.mobileNumberOnlyNumbers");
        if (value && value?.length !== 4)
          return t("validation.postalCodeFourDigits");
        break;
      case "fax1":
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.faxNumberOnlyNumbers");
        if (value && value?.length < 2)
          return t("validation.twoDigitsOrMoreRequired");
        if (value && value?.length > 5)
          return t("validation.postalCodeFiveDigits");
        break;
      case "fax2":
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.faxNumberOnlyNumbers");
        if (value && value?.length > 4)
          return t("validation.postalCodeFourDigits");
        break;
      case "fax3":
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.faxNumberOnlyNumbers");
        if (isWorkPlaceRequired && value?.length !== 4)
          return t("validation.postalCodeFourDigits");
        break;
    }

    return "";
  };

  const handleChangeSubValue = (field: string, value?: string) => {
    setSubValue((prev) => ({ ...prev, [field]: value }));
    const error = validateField(field, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: error,
    }));
  };


  const fetchOptionsFromAPI = async (query: string): Promise<Company[]> => {
    try {
      const response = await fetchAddressCompany(query);
      const data = response;

      if (data.result_code !== 0 || !Array.isArray(data.list)) {
        throw new Error("Invalid response from API");
      }

      return data.list.map((item: any) => ({
        lbc: item.lbc,
        cname: item.cname,
        addr: item.addr,
        addr1: item.addr1,
        addr2: item.addr2,
        addr3: item.addr3,
        addr4: item.addr4,
        addr5: item.addr5,
        bldg: item.bldg,
        zip: item.zip,
      }));
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div id={id} className="component__workPlace-info">
      <h3
        className="contact-info_title"
        onClick={() => isEdit && setVisibleForms(!visibleForms)}
        style={{ cursor: isEdit ? "pointer" : "default" }}
      >
        <img className="-icon" src="/images/ico_address.svg" />
        {t("features.userSetting.contact.contactTitWork")}
        {isEdit && (visibleForms ? <Minus /> : <Plus />)}
      </h3>
      {visibleForms ? (
        <>
          <dl className="contact-body">
            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt className="-middle">
                <label>
                  <span>{t("features.userSetting.contact.companyName")}</span>
                  {isEdit && (forceWorkPlaceValidate || userMetaData?.profile?.contactType != 1) ? (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  ) : (
                    ""
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <div className="form-col -col2 ">
                    <div className=" w-100 form-col_item">
                      <CustomAutocomplete<Company>
                        id="corp"
                        fetchData={fetchOptionsFromAPI}
                        placeholder={t(
                          "features.userSetting.contact.companyPlaceholder"
                        )}
                        options={[]}
                        getOptionLabel={(option: Company | string) => {
                          if (typeof option === "string") {
                            return option;
                          }
                          return `${option.cname}`;
                        }}
                        maxLength={50}
                        value={userMetaData?.workPlaceInfo?.companyName ?? ""}
                        onChange={(selected: any | null) => {
                          if (selected) {
                            const zip = selected.zip;
                            const errorZip01 = validateField(
                              "zip01",
                              zip.slice(0, 3)
                            );
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              zip01: errorZip01,
                            }));
                            const errorZip02 = validateField(
                              "zip02",
                              zip.slice(3)
                            );
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              zip02: errorZip02,
                            }));
                            setSubValue((prevState) => ({
                              ...prevState,
                              zip01: zip.slice(0, 3),
                              zip02: zip.slice(3),
                            }));

                            const errorLine = validateField(
                              "line",
                              selected?.addr4 + selected?.addr5
                            );
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              line: errorLine,
                            }));
                            setState((prevState) => ({
                              ...prevState,
                              userMetaData: {
                                ...prevState.userMetaData,
                                workPlaceInfo: {
                                  ...prevState.userMetaData?.workPlaceInfo,
                                  lbcCode: userMetaData?.workPlaceInfo
                                    ?.companyName
                                    ? selected.lbc
                                    : "",
                                  prefectureCode: parseInt(
                                    workAddressSelect.find(
                                      (address) => address.label == selected?.addr1
                                    )?.value ?? "0"
                                  ),
                                  city: selected?.addr2 + selected?.addr3,
                                  line: selected?.addr4 + selected?.addr5,
                                },
                              },
                            }));
                          }
                        }}
                        InputChange={(value: string) => {
                          handleChangeSubValue("companyName", value);
                          setState((prevState) => ({
                            ...prevState,
                            userMetaData: {
                              ...prevState.userMetaData,
                              workPlaceInfo: {
                                ...prevState.userMetaData?.workPlaceInfo,
                                companyName: value,
                                line: "",
                                postalCode: "",
                                city: "",
                                prefectureCode: 0,
                              },
                            },
                          }));

                          setSubValue((prevState) => ({
                            ...prevState,
                            zip01: "",
                            zip02: "",
                          }));

                          const error = validateField("companyName", value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            companyName: error,
                          }));
                        }}
                        withChecked={true}
                        error={
                          (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate) &&
                          errors.companyName
                            ? true
                            : false
                        }
                      />
                      <ErrorMsg
                        error={
                          (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                            ? errors.companyName
                            : ""
                        }
                        className="invalid-danger"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="data-confirm">
                    {userMetaData?.workPlaceInfo?.companyName}
                  </div>
                )}
              </dd>
            </div>
            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt>
                <label>
                  <span>
                    {t("features.userSetting.contact.workPostalCode")}
                  </span>
                  {isEdit && (forceWorkPlaceValidate || userMetaData?.profile?.contactType != 1) && (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <div className="form-col -col2 ">
                    <div className="form-col_item w-100">
                      <div className="form-input d-flex align-items-center form-zip">
                        <Input
                          name="zip01"
                          maxLength={3}
                          width={82}
                          id="zip01"
                          value={subValue.zip01}
                          validateMess=""
                          placeholder="100"
                          onChange={(value) =>
                            handleChangeSubValue("zip01", value)
                          }
                          onBlur={(value) => {
                            if (value && value.length < 3) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                zip01: t("validation.postalCodeThreeDigits"),
                              }));
                            }
                          }}
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="zip02"
                          width={82}
                          maxLength={4}
                          id="zip02"
                          placeholder="0001"
                          value={subValue.zip02}
                          onChange={(value) =>
                            handleChangeSubValue("zip02", value)
                          }
                          onBlur={(value) => {
                            if (value && value.length < 4) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                zip02: t("validation.postalCodeFourDigits"),
                              }));
                            }
                          }}
                        />
                        <a
                          href="https://www.post.japanpost.jp/zipcode/index.html"
                          rel="noopener"
                          className="register-form-input_external -vertical"
                          target="_blank"
                        >
                          {t("features.userSetting.contact.postalCodeInfo")}
                        </a>
                      </div>
                      <ErrorMsg
                        error={
                          (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                            ? errors.zip01
                              ? errors.zip01
                              : errors.zip02
                              ? errors.zip02
                              : ""
                            : ""
                        }
                        className="invalid-danger"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="data-confirm">
                    {userMetaData?.workPlaceInfo?.postalCode}
                  </div>
                )}
              </dd>
            </div>

            <div
              className={`body-item -address ${
                isEdit ? "item_edit" : "item_confirm"
              }`}
            >
              <dt className="-px5">
                <label>
                  <span>{t("features.userSetting.contact.workAddress")}</span>
                  {isEdit && (forceWorkPlaceValidate || userMetaData?.profile?.contactType != 1) && (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <>
                    <div className="form-col -col">
                      <div className="form-col_item w-100">
                        <Select
                          name="prefectureCode"
                          id="prefectureCode"
                          value={
                            userMetaData?.workPlaceInfo?.prefectureCode?.toString() ??
                            "0"
                          }
                          error={
                            (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate) &&
                            !!errors.prefectureCode
                          }
                          label={t("general.prefecture")}
                          onChange={(value) => {
                            const error = validateField(
                              "prefectureCode",
                              value
                            );
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              prefectureCode: error,
                            }));
                            setState((prevState) => ({
                              ...prevState,
                              userMetaData: {
                                ...prevState.userMetaData,
                                workPlaceInfo: {
                                  ...prevState.userMetaData?.workPlaceInfo,
                                  prefectureCode: parseInt(value),
                                },
                              },
                            }));
                          }}
                          classNameWrapper="col-5"
                          options={workAddressSelect}
                          defaultValue="0"
                          customSelect={true}
                        />
                        <ErrorMsg
                          error={
                            (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                              ? errors.prefectureCode
                              : ""
                          }
                          className="invalid-danger"
                        />
                      </div>
                    </div>

                    <div className="form-col -col2  mt-4">
                      <div className="form-col_item w-100">
                        <Input
                          maxLength={80}
                          name="city"
                          label="市区町村"
                          placeholder="例）港区南青山"
                          id="city"
                          error={
                            (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                              ? errors.city
                              : ""
                          }
                          validateMess={
                            (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                              ? errors.city
                              : ""
                          }
                          value={userMetaData?.workPlaceInfo?.city ?? ""}
                          onChange={(value) => {
                            const error = validateField("city", value);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              city: error,
                            }));
                            setState((prevState) => ({
                              ...prevState,
                              userMetaData: {
                                ...prevState.userMetaData,
                                workPlaceInfo: {
                                  ...prevState.userMetaData?.workPlaceInfo,
                                  city: value,
                                },
                              },
                            }));
                          }}
                          withChecked={true}
                        />
                      </div>
                    </div>

                    <div className="form-col -col2  mt-4">
                      <div className="form-col_item w-100">
                        <div className="form-input">
                          <Input
                            maxLength={200}
                            name="line"
                            value={userMetaData?.workPlaceInfo?.line ?? ""}
                            error={
                              (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                                ? errors.line
                                : ""
                            }
                            validateMess={
                              (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                                ? errors.line
                                : ""
                            }
                            onChange={(value) => {
                              const error = validateField("line", value);
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                line: error,
                              }));
                              setState((prevState) => ({
                                ...prevState,
                                userMetaData: {
                                  ...prevState.userMetaData,
                                  workPlaceInfo: {
                                    ...prevState.userMetaData?.workPlaceInfo,
                                    line: value,
                                  },
                                },
                              }));
                            }}
                            label={t(
                              "features.userSetting.contact.addressDetails"
                            )}
                            placeholder={t(
                              "features.userSetting.contact.addressExample"
                            )}
                            id="address02"
                            withChecked={true}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="data-confirm">
                    {userMetaData?.workPlaceInfo?.prefectureCode?.toString() !=
                    "48"
                      ? workAddressSelect.find(
                          (item) =>
                            item.value ===
                            userMetaData?.workPlaceInfo?.prefectureCode?.toString()
                        )?.label
                      : ""}
                    {userMetaData?.workPlaceInfo?.city}
                    {userMetaData?.workPlaceInfo?.line}
                  </div>
                )}
              </dd>
            </div>
            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt className="-middle">
                <label>
                  <span>
                    {t("features.userSetting.contact.departmentName")}
                  </span>
                  {isEdit && (forceWorkPlaceValidate || userMetaData?.profile?.contactType != 1) && (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <div className="form-col -col2 ">
                    <div className=" w-100 form-col_item   ">
                      <Input
                        maxLength={50}
                        name="departmentName"
                        value={
                          userMetaData?.workPlaceInfo?.departmentName ?? ""
                        }
                        error={errors.departmentName}
                        validateMess={errors.departmentName}
                        onChange={(value) => {
                          handleChangeSubValue("departmentName", value)
                          const error = validateField("departmentName", value);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            departmentName: error,
                          }));
                          setState((prevState) => ({
                            ...prevState,
                            userMetaData: {
                              ...prevState.userMetaData,
                              workPlaceInfo: {
                                ...prevState.userMetaData?.workPlaceInfo,
                                departmentName: value,
                              },
                            },
                          }));
                        }}
                        id="departmentName"
                        placeholder={t(
                          "features.userSetting.contact.departmentNamePlaceholder"
                        )}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="data-confirm">
                    {userMetaData?.workPlaceInfo?.departmentName}
                  </div>
                )}
              </dd>
            </div>
            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt className="-middle">
                <label>
                  <span>{t("features.userSetting.contact.phoneNumber")}</span>
                  {isEdit && (forceWorkPlaceValidate || userMetaData?.profile?.contactType != 1) && (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <>
                    <div className="form-col -col2 ">
                      <div className="form-col_item  w-100">
                        <div className="form-input d-flex align-items-center">
                          <Input
                            name="phone01"
                            maxLength={4}
                            id="phone01"
                            value={subValue.phone01 ?? ""}
                            placeholder="03"
                            onChange={(value) =>
                              handleChangeSubValue("phone01", value)
                            }
                            onBlur={(value) => {
                              if (value && value.length < 2) {
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  phone01: t(
                                    "validation.twoDigitsOrMoreRequired"
                                  ),
                                }));
                              }
                            }}
                          />
                          <span className="form-input_unit -hyphen">-</span>
                          <Input
                            name="phone02"
                            id="phone02"
                            value={subValue.phone02 ?? ""}
                            placeholder="0123"
                            maxLength={4}
                            onChange={(value) =>
                              handleChangeSubValue("phone02", value)
                            }
                          />
                          <span className="form-input_unit -hyphen">-</span>
                          <Input
                            name="phone03"
                            value={subValue.phone03 ?? ""}
                            id="phone03"
                            placeholder="4567"
                            maxLength={4}
                            onChange={(value) =>
                              handleChangeSubValue("phone03", value)
                            }
                          />
                        </div>
                        <ErrorMsg
                          error={
                            (userMetaData?.profile?.contactType !== 1 || forceWorkPlaceValidate)
                              ? errors.phone01
                                ? errors.phone01
                                : errors.phone02
                                ? errors.phone02
                                : errors.phone03
                                ? errors.phone03
                                : ""
                              : ""
                          }
                          className="invalid-danger"
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="txt-gray data-confirm">
                      {t("general.phone_number")}
                    </div>
                    <div className="data-confirm">
                      {userMetaData?.workPlaceInfo?.phoneNumber}
                    </div>
                    {userMetaData?.workPlaceInfo?.mobilePhoneNumber && (
                      <>
                        <div className="txt-gray data-confirm mt-2">
                          {t("features.userSetting.contact.mobileNumber")}
                        </div>
                        <div className="data-confirm">
                          {userMetaData?.workPlaceInfo?.mobilePhoneNumber}
                        </div>
                      </>
                    )}
                  </>
                )}
              </dd>
            </div>

            {isEdit && (
              <div className="body-item item_edit">
                <dt className="-middle">
                  <label>
                    <span>{t("features.userSetting.contact.mobileNum")}</span>
                  </label>
                </dt>
                <dd>
                  <div className="form-col -col2">
                    <div className="form-col_item w-100">
                      <div className="form-input d-flex align-items-center">
                        <Input
                          name="mobile_phone01"
                          maxLength={3}
                          value={subValue.mobile01 ?? ""}
                          id="mobile_phone01"
                          onChange={(value) =>
                            handleChangeSubValue("mobile01", value)
                          }
                          placeholder="090"
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="mobile_phone02"
                          value={subValue.mobile02 ?? ""}
                          maxLength={4}
                          id="mobile_phone02"
                          onChange={(value) =>
                            handleChangeSubValue("mobile02", value)
                          }
                          placeholder="0123"
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="mobile_phone03"
                          value={subValue.mobile03 ?? ""}
                          maxLength={4}
                          onChange={(value) =>
                            handleChangeSubValue("mobile03", value)
                          }
                          id="mobile_phone03"
                          placeholder="4567"
                        />
                      </div>
                      <ErrorMsg
                        error={
                          errors.mobile01
                            ? errors.mobile01
                            : errors.mobile02
                            ? errors.mobile02
                            : errors.mobile03
                            ? errors.mobile03
                            : ""
                        }
                        className="invalid-danger"
                      />
                    </div>
                  </div>
                </dd>
              </div>
            )}

            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt className="-middle">
                <label>
                  <span>{t("features.userSetting.contact.faxNum")}</span>
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <div className="form-col -col2">
                    <div className="form-col_item w-100">
                      <div className="form-input d-flex align-items-center">
                        <Input
                          name="fax1"
                          maxLength={4}
                          value={subValue.fax1 ?? ""}
                          id="fax1"
                          onChange={(value) =>
                            handleChangeSubValue("fax1", value)
                          }
                          placeholder="03"
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="fax2"
                          value={subValue.fax2 ?? ""}
                          maxLength={4}
                          id="fax2"
                          onChange={(value) =>
                            handleChangeSubValue("fax2", value)
                          }
                          placeholder="0123"
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="fax3"
                          value={subValue.fax3 ?? ""}
                          maxLength={4}
                          onChange={(value) =>
                            handleChangeSubValue("fax3", value)
                          }
                          id="fax3"
                          placeholder="4567"
                        />
                      </div>
                      <ErrorMsg
                        error={
                          errors.fax1
                            ? errors.fax1
                            : errors.fax2
                            ? errors.fax2
                            : errors.fax3
                            ? errors.fax3
                            : ""
                        }
                        className="invalid-danger"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="data-confirm">
                    {userMetaData?.workPlaceInfo?.faxNumber}
                  </div>
                )}
              </dd>
            </div>
          </dl>{" "}
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default WorkPlace;
